import { Injectable } from '@angular/core';
import { Message, MessageTypes } from './message';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map } from 'rxjs/operators';


// trying to follow the recommended way of Observable Data Services
// https://blog.angular-university.io/how-to-build-angular2-apps-using-rxjs-observable-data-services-pitfalls-to-avoid/
// https://github.com/jhades/angular2-rxjs-observable-data-services/blob/master/src/state/TodoStore.ts

@Injectable()
export class MessageService {

    protected _message: BehaviorSubject<Message> = new BehaviorSubject({text: '', type: MessageTypes.None});

    constructor() { }

    get message() {
        return this._message; // new Observable(fn => this._message.subscribe(fn));
    }

    public setMessage(text: string, type: MessageTypes) {
        // console.log('set message to ' + text);
        this._message.next({text: text, type: type});
    }

    public clearMessage() {
        this._message.next({text: '', type: MessageTypes.None});
    }
}



// WEBPACK FOOTER //
// ./src/app/message.service.ts